/* eslint-disable react/require-default-props,react/forbid-prop-types,react/destructuring-assignment */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Checkbox.scss';

export class Checkbox extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    label: PropTypes.node.isRequired,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    children: PropTypes.any,
  };

  static defaultProps = {
    error: null,
  };

  onChange = (event) => {
    this.props.onChange(event.target.checked);
  };

  render() {
    const { name, checked, disabled, label, error } = this.props;

    return (
      <form-checkbox>
        <label>
          <input
            type="checkbox"
            {...{ name, checked, disabled }}
            onChange={this.onChange}
            className={classNames({ error })}
          />
          {label}
        </label>
        {error && <span className="ol-checkbox-error">{error}</span>}
        {this.props.children}
      </form-checkbox>
    );
  }
}
